import React from "react";
import Chart from "react-apexcharts";

function PunjabPrisonsBreakdownYear() {
  var options = {
    series: [
      {
        name: "",
        data: [1, 2, 2, 2, 9, 27],
      },
    ],
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    colors: ["#2381A2"],
    dataLabels: {
      style: {
        colors: ["#000"],
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    xaxis: {
      categories: [
        "Women Jails",
        "High Security Jails",
        "Sub Jails",
        "Juvenile Jails",
        "Central Jails",
        "District Jails",
      ],
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: true,
        trim: false,
      },
    },
    // legend: {
    //   position: "right",
    //   offsetY: 40,
    // },
    fill: {
      opacity: 1,
    },
  };
  return (
    <div>
      <Chart
        options={options}
        series={options.series}
        type="bar"
        width="100%"
      />
    </div>
  );
}

export default PunjabPrisonsBreakdownYear;
